import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { LocalService } from '../../../Services/local.service';
import { LoginService } from '../../Services/login.service';
import { ProposalInformationService } from 'src/app/Modules/medical/modules/broker/modules/buy-policy/services/proposal-information.service';
import { CategoryDialogComponent } from 'src/app/Modules/medical/modules/broker/modules/buy-policy/components/category-dialog/category-dialog.component';
import { GlobalService } from 'src/app/global.service';
import { QuotationDetails } from 'src/app/Modules/medical/modules/models/quotation-details.model';

@Component({
  selector: 'app-lob-list-pop',
  templateUrl: './lob-list-pop.component.html',
  styleUrls: ['./lob-list-pop.component.css']
})
export class LobListPopComponent implements OnInit {
  userType: string;
  productlist: any;

  motordesc: any;
  personaldesc: any;
  firedesc: any;
  traveldesc: any;
  medicaldesc: any;


  motor: any;
  fire: any;
  general: any;
  travel: any;
  medical: any;

  motorProducts: any[] = [
    { value: 'Motor Corporate', viewValue: 'Motor Corporate' },
    { value: 'Motor Retail', viewValue: 'Motor Retail' }
  ];

  marineProducts: any[] = [
    { value: 'Motor Corporate', viewValue: 'Motor Corporate' },
    { value: 'Motor Retail', viewValue: 'Motor Retail' }
  ];

  travelProducts: any[] = [
    { value: 'Motor Corporate', viewValue: 'Motor Corporate' },
    { value: 'Motor Retail', viewValue: 'Motor Retail' }
  ];

  fireProducts: any[] = [
    { value: 'Motor Corporate', viewValue: 'Motor Corporate' },
    { value: 'Motor Retail', viewValue: 'Motor Retail' }
  ];
  //constructor( private router: Router, private _formbuilder: FormBuilder, public dialog: MatDialogRef<LobListPopComponent>) {

  constructor(private router: Router, private _formbuilder: FormBuilder,
    public dialog: MatDialog, public proposal: ProposalInformationService, private _local: LocalService, public loginservice: LoginService, public global: GlobalService) {


  }

  selectMotorProduct(ev) {

    this.router.navigate(["motor/quote/getQuote"])
  }

  ngOnInit() {





    var userType = sessionStorage.getItem('userType');
    this.userType = userType;
    if (userType != undefined && userType == "Agent") {
      //document.getElementById('motorProposal').style.display="block";
    }
    this.getproductlist();
    this.getProductdescription();
  }

  // Medica Insurance

  openCategoryDialog(): void {
    // this.router.navigate(["/medical/broker/buypolicy"]);
    this.dialog.closeAll();
    this._local.removeString("quoteNumber")
    this.proposal.getCategory().subscribe(success => {
      const dialogRef = this.dialog.open(CategoryDialogComponent, {
        width: '700px',
        data: success["responseBody"]
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result.code == "INDL") {
          this.global.proposal = new QuotationDetails()
          this.global.review = false
          this.router.navigate(["/medical/agent/get_quote/individual"])
        } else
          this.router.navigate(["/medical/agent/get_quote/corporate"]);
      })
    })
  }

  selectedTab(eve) {

    if (eve == "0") {
      document.getElementById('generallri').style.visibility = 'visible';
      document.getElementById('generallri').style.display = '';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'visible';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';

    } else if (eve == "1") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = '';
      document.getElementById('healthlri').style.visibility = 'visible';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "2") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = '';
      document.getElementById('motorlri').style.visibility = 'visible';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "3") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = '';
      document.getElementById('propertylri').style.visibility = 'visible';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "4") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = '';
      document.getElementById('travelri').style.visibility = 'visible';
    }
  }
  getproductlist() {

    var userName = sessionStorage.getItem('userName');
    this.loginservice.getproductlist(userName).subscribe((res: any) => {
      if (res.responseBody != undefined) {

        this.productlist = res.responseBody.productlist;
        //Displaying only the selected Products

        for (let i = 0; i < this.productlist.length; i++) {
          this.medical = "1";
          document.getElementById('healthlri').style.display = '';
          document.getElementById('healthlri').style.visibility = 'visible';
          if (this.productlist[i] == "7021") {
            this.motor = "01";
            document.getElementById('motorlri').style.display = '';
            document.getElementById('motorlri').style.visibility = 'visible';
          } else if (this.productlist[i] == "1017") {
            this.general = "02";
            document.getElementById('generallri').style.visibility = 'visible';
            document.getElementById('generallri').style.display = '';
          } else if (this.productlist[i] == "8080") {
            this.fire = "03";
            document.getElementById('propertylri').style.display = '';
            document.getElementById('propertylri').style.visibility = 'visible';
          } else if (this.productlist[i] == "6070") {
            this.travel = "04";
            document.getElementById('travelri').style.display = '';
            document.getElementById('travelri').style.visibility = 'visible';
          }
        }
      }

    })
  }

  getProductdescription() {

    this.loginservice.getProductdescription().subscribe((res: any) => {
      if (res.responseBody != undefined) {

        this.motordesc = res.responseBody.productdesc[0].PC_LONG_DESC;
        this.personaldesc = res.responseBody.productdesc[1].PC_LONG_DESC;
        this.firedesc = res.responseBody.productdesc[2].PC_LONG_DESC;
        this.traveldesc = res.responseBody.productdesc[3].PC_LONG_DESC;
        this.medicaldesc = res.responseBody.productdesc[4].PC_LONG_DESC;
      }
    })
  }

}
